<template>
  <div class="personal-benefits">
    <div class="personal-benefits-about">
      <p v-html="about"></p>
    </div>
    <div class="personal-benefits-gallery">
      <div
        v-for="(benefit, i) in benefits"
        :key="i"
        class="personal-benefit"
        :style="`background-image: url(${benefit.image_url})`"
        @click="onBenefitClick(benefit)"
      >
        <div class="personal-benefit-ratio"></div>
        <div class="personal-benefit-overlay">
          <div class="personal-benefit-overlay-content">
            <div class="icon icon-gift"></div>
            {{ hoverMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $t } from "../../i18n";

export default {
  props: {
    about: {
      type: String,
      default: "",
    },
    benefits: {
      type: Array,
      default: [],
    },
    hoverMessage: {
      type: String,
      default: $t("למידע נוסף וניצול ההטבה"),
    },
  },

  methods: {
    onBenefitClick(benefit) {
      const $modal = $(".personal-benefit-modal");
      $modal.find(".personal-benefit-image").attr("src", benefit.image_url);
      $modal.modal().show();
    },
  },
};
</script>
